module.exports = __webpack_public_path__ + "assets/img/login.56ee519d.jpg";